// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { DnsSourceTypeSchema } from '../inputTypeSchemas/DnsSourceTypeSchema'

/////////////////////////////////////////
// DOMAIN EVIDENCE SCHEMA
/////////////////////////////////////////

export const DomainEvidenceSchema = z.object({
  evidenceType: DnsSourceTypeSchema,
  text: z.string(),
  timestamp: z.coerce.date().nullable(),
})

export type DomainEvidence = z.infer<typeof DomainEvidenceSchema>

export default DomainEvidenceSchema;
